// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3IXyy","left":"InfoRow_left__3udlN"};